// extracted by mini-css-extract-plugin
export default {"photo":"UnsplashPhotoUI_photo__cAoN0"};